<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Desengates</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Novo Desengate"
          icon="assets/add.svg"
          (click)="navegarNovoDesengate()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem</div>
        <div class="align-button">
          <form
            [formGroup]="form"
            (ngModelChange)="getDesengates()"
            class="table-filters">
            <app-input
              label="N° do Agendamento"
              placeholder="Digite aqui"
              name="FK_AGND"
              formControlName="FK_AGND"
              width="100%"></app-input>
            <app-input
              label="Empresa"
              placeholder="Digite aqui"
              name="NM_EPSA"
              formControlName="NM_EPSA"
              width="100%"></app-input>
            <app-input
              label="Motorista"
              placeholder="Digite aqui"
              name="NM_MTRT"
              formControlName="NM_MTRT"
              width="100%"></app-input>
            <app-input
              label="Placa do Veículo"
              placeholder="Digite aqui"
              name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA"
              mask="AAA-0A00"
              width="100%"></app-input>
            <span></span>
            <app-input
              type="select"
              label="Situação"
              name="NU_STTS"
              formControlName="NU_STTS"
              width="100%"
              [selectData]="situacaoOptions"
              (ngModelChange)="onSituacaoChange($event)"></app-input>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"></app-input>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <form
      [formGroup]="form"
      (ngModelChange)="getDesengates()"
      class="table-filters">
      <app-input
        label="N° do Agendamento"
        placeholder="Digite aqui"
        name="FK_AGND"
        formControlName="FK_AGND"
        width="100%"></app-input>
      <app-input
        label="Empresa"
        placeholder="Digite aqui"
        name="NM_EPSA"
        formControlName="NM_EPSA"
        width="100%"></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite aqui"
        name="NM_MTRT"
        formControlName="NM_MTRT"
        width="100%"></app-input>
      <app-input
        label="Placa do Veículo"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        mask="AAA-0A00"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
